import { Link, useMatchRoute } from '@tanstack/react-router';
import { BarChart3, Activity, Users, Settings, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { to: '/admin', label: 'Overview', icon: LayoutDashboard, exact: true },
  { to: '/admin/scraping', label: 'Scraping', icon: BarChart3 },
  { to: '/admin/availability', label: 'Availability', icon: Activity },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/system', label: 'System', icon: Settings },
] as const;

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const matchRoute = useMatchRoute();
  const { user } = useAuth();

  return (
    <div className="flex h-screen bg-[#0f1117] text-white overflow-hidden">
      <nav className="w-[200px] bg-[#161b22] border-r border-[#21262d] flex flex-col flex-shrink-0">
        <div className="px-5 py-5 text-[#e94560] font-bold text-sm tracking-wide">
          HELLACAMPING
        </div>
        <div className="flex flex-col gap-0.5 px-2">
          {navItems.map(({ to, label, icon: Icon, ...rest }) => {
            const exact = 'exact' in rest ? rest.exact : false;
            const isActive = exact
              ? matchRoute({ to, fuzzy: false })
              : matchRoute({ to, fuzzy: true });
            return (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-3 px-3 py-2 rounded-md text-[13px] transition-colors border-l-[3px] ${
                  isActive
                    ? 'bg-[#1c2129] text-white border-[#10b981]'
                    : 'text-[#8b949e] border-transparent hover:text-[#c9d1d9] hover:bg-[#1c2129]'
                }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            );
          })}
        </div>
        <div className="mt-auto px-5 py-4 border-t border-[#21262d]">
          <div className="text-[#8b949e] text-[11px] truncate">{user?.email ?? 'Admin'}</div>
        </div>
      </nav>
      <main className="flex-1 overflow-y-auto p-6 lg:p-8">
        {children}
      </main>
    </div>
  );
}
